module.exports = __webpack_public_path__ + "image-d9bbfa110b57.png";